import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ILocationFeature } from './location.feature.state';
import { LocationState } from './location.state';

export const getLocationState: MemoizedSelector<ILocationFeature, LocationState> = createFeatureSelector<LocationState>(
  nameof<ILocationFeature>('locationFeature')
);

export const getLocationName = createSelector(getLocationState, (state: LocationState) => state.locationName);
export const getIsLoading = createSelector(getLocationState, (state: LocationState) => state.isLoading);
export const getFailures = createSelector(getLocationState, (state: LocationState) => state.failures);
export const getLocationGuid = createSelector(getLocationState, (state: LocationState) => state.locationGuid);
